import { memo } from 'react';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Link } from '@/hen-ui/atomics/Link';
import { Badge } from '@/hen-ui/atomics/Badge';
import { Flex } from '@/hen-ui/composites/Flex';
import { sponsoredCardLogoBoxVariants } from './sponsored-card.variants';
import type { SponsoredCardProps } from './types';

type SponsoredCardIdentityProps = Pick<
  SponsoredCardProps,
  'logoSrc' | 'logoAlt' | 'name' | 'nameHref' | 'onNameClick' | 'metaItems'
>;

export const SponsoredCardIdentity = memo(function SponsoredCardIdentity({
  logoSrc,
  logoAlt,
  name,
  nameHref,
  onNameClick,
  metaItems,
}: SponsoredCardIdentityProps) {
  return (
    <Flex direction='row' align='center' gap='sm' className='md:gap-md w-full'>
      <div className={sponsoredCardLogoBoxVariants()}>
        <img
          src={logoSrc}
          alt={logoAlt}
          className='max-h-full max-w-full object-contain'
          loading='lazy'
          decoding='async'
        />
      </div>
      <Flex direction='column' gap='xxs' className='min-w-0 flex-1'>
        {nameHref ? (
          <Link
            href={nameHref}
            onClick={onNameClick}
            className='text-h3 font-bold'
            variant='black'
            underline='none'
          >
            {name}
          </Link>
        ) : (
          <Heading variant='h3'>{name}</Heading>
        )}
        {metaItems && metaItems.length > 0 && (
          <Flex direction='row' align='center' gap='xxs' className='flex-wrap'>
            {metaItems.map((item, i) => (
              <Badge
                key={i}
                size='sm'
                className='text-body font-normal border border-white bg-neutral-50'
              >
                {item}
              </Badge>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
});
